import {ValidationType} from './ValidationType'

export const EmailSignaturesValidation = {
  ID: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Description: {
    validationType: ValidationType.TextUpperLowerCase,
    isRequired: true,
    maxLength: 30,
    maxValue: 0
  },
  Body: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  },
  Inactive: {
    validationType: ValidationType.Numeric,
    isRequired: false,
    maxLength: 3,
    maxValue: 255
  },
  Header: {
    validationType: ValidationType.TextFreeFormat,
    isRequired: false,
    maxLength: 0,
    maxValue: 0
  }
};
